(()=>{
  const __shopifySectionId = document.currentScript?.dataset.sectionId || '';

  const SECTION_ID=("" + __shopifySectionId + "");
  const ROOT_ID='YurchakShop-'+SECTION_ID;

  const renderCollection=async(url,pushState=true)=>{
    const current=document.getElementById(ROOT_ID);
    if(!current)return;
    const canonical=new URL(url,window.location.href);
    canonical.searchParams.delete('section_id');
    const requestUrl=new URL(canonical.toString());
    requestUrl.searchParams.set('section_id',SECTION_ID);
    current.setAttribute('aria-busy','true');
    try{
      const response=await fetch(requestUrl.toString(),{
        credentials:'same-origin',
        cache:'no-store',
        headers:{'X-Requested-With':'XMLHttpRequest'}
      });
      if(!response.ok)throw new Error('Could not update products.');
      const html=await response.text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const fresh=doc.getElementById(ROOT_ID);
      if(!fresh)throw new Error('Collection section was not returned.');
      current.replaceWith(fresh);
      document.body.classList.remove('ycs-filter-open');
      if(pushState)history.pushState({yurchakCollection:true},'',canonical.toString());
      window.YurchakCollectionShopInit?.();
      window.YurchakCollectionEnhancementsInit?.();
      document.dispatchEvent(new CustomEvent('yurchak:collection-rendered',{detail:{url:canonical.toString()}}));
    }catch(error){
      current.removeAttribute('aria-busy');
      if(pushState)window.location.assign(canonical.toString());
    }
  };

  const init=()=>{
    const root=document.getElementById(ROOT_ID);
    if(!root||root.dataset.ready==='true')return;
    root.dataset.ready='true';

    const filterForm=root.querySelector('#YurchakFilters-'+SECTION_ID);
    const sort=root.querySelector('.ycs__sort select');
    const sortHidden=root.querySelector('[data-ycs-sort-hidden]');

    filterForm?.addEventListener('submit',event=>{
      event.preventDefault();
      if(sort&&sortHidden)sortHidden.value=sort.value;
      const url=new URL(filterForm.action,window.location.href);
      const params=new URLSearchParams(new FormData(filterForm));
      params.delete('page');
      url.search=params.toString();
      renderCollection(url,true);
    });

    root.querySelectorAll('[data-ycs-submit]').forEach(el=>el.addEventListener('change',()=>{
      if(el===sort&&sortHidden)sortHidden.value=sort.value;
      filterForm?.requestSubmit();
    }));

    root.addEventListener('click',event=>{
      const link=event.target.closest?.('.ycs__pagination a,.ycs__clear,.ycs__empty a');
      if(!link)return;
      const url=new URL(link.href,window.location.href);
      if(url.origin!==window.location.origin)return;
      event.preventDefault();
      renderCollection(url,true);
    });

    const panel=root.querySelector('[data-ycs-filters]');
    const open=()=>{panel?.classList.add('is-open');document.body.classList.add('ycs-filter-open')};
    const close=()=>{panel?.classList.remove('is-open');document.body.classList.remove('ycs-filter-open')};
    root.querySelector('[data-ycs-filter-open]')?.addEventListener('click',open);
    root.querySelectorAll('[data-ycs-filter-close]').forEach(el=>el.addEventListener('click',close));
  };

  window.YurchakCollectionShopInit=init;
  window.YurchakCollectionRender=renderCollection;

  if(!window.__yurchakCollectionPopstateBound){
    window.__yurchakCollectionPopstateBound=true;
    window.addEventListener('popstate',()=>renderCollection(window.location.href,false));
  }

  init();
})();
